import { NextApiRequest, NextApiResponse } from 'next';
import { serialize } from 'cookie';
import { TokenPair } from '../interface/api';

type AccessTokenKeysType = 'access-token-account-choosing' | 'access-token';
type RefreshTokenKeysType = 'refresh-token-account-choosing' | 'refresh-token';

export const extractTokensFromCookies = (
  req: NextApiRequest,
  custKey: { accessToken?: AccessTokenKeysType; refreshToken?: RefreshTokenKeysType } = {}
): TokenPair | null => {
  const cookies = req.cookies;
  const accessToken = cookies[custKey?.accessToken || 'access-token'];
  const refreshToken = cookies[custKey?.refreshToken || 'refresh-token'];

  if (!accessToken || !refreshToken) {
    return null;
  }

  return {
    accessToken,
    refreshToken,
  };
};

export const clearAuthCookies = (res: NextApiResponse | any) => {
  if (!res || typeof res.setHeader !== 'function') return;

  const expiredCookies = [
    serialize('access-token', '', {
      maxAge: 0,
      expires: new Date(0),
      path: '/',
      httpOnly: true,
    }),
    serialize('refresh-token', '', {
      maxAge: 0,
      expires: new Date(0),
      path: '/',
      httpOnly: true,
    }),
  ];

  const prevCookies = res.getHeader?.('Set-Cookie');
  if (prevCookies) {
    const prevArray = Array.isArray(prevCookies) ? prevCookies : [String(prevCookies)];
    const filtered = prevArray.filter(
      (c) => !c.startsWith('access-token=') && !c.startsWith('refresh-token=')
    );
    res.setHeader('Set-Cookie', [...filtered, ...expiredCookies]);
  } else {
    res.setHeader('Set-Cookie', expiredCookies);
  }
};
